<span
  class="toggle-container"
  [attr.tabindex]="disabled ? null : 0"
  (focus)="onFocusChange()"
  (blur)="onFocusChange()">
  <span class="toggle-background">
    <ppl-icon
      svgIcon="checkmark-toggle"
      class="check"
      width="14px"
      height="14px"
      fill="var(--ppl-teal-600)"
      [hoverEnabled]="false"></ppl-icon>
    <ppl-icon
      svgIcon="closebold-toggle"
      class="cross"
      width="12px"
      height="12px"
      fill="var(--ppl-red-600)"
      [hoverEnabled]="false"></ppl-icon>
  </span>
  <span class="toggle-thumb">
    <ppl-icon
      svgIcon="slider"
      width="26px"
      height="20px"
      [hoverEnabled]="false"></ppl-icon>
  </span>
</span>
@if (ngUiTheme === 'fabric') {
  <div class="toggle-state-label">
    @if (value) {
      On
    }
    @if (!value) {
      Off
    }
  </div>
}
@if (label || labelTemplate) {
  <span
    class="toggle-label"
    [style.color]="labelColor"
    [attr.title]="label">
    @if (labelTemplate) {
      <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    } @else {
      {{ label }}
    }
  </span>
}
